// extracted by mini-css-extract-plugin
module.exports = {"salesImage":"AdvantageBlade-module--salesImage--1TeWt","rowStyle":"AdvantageBlade-module--rowStyle--3ra5y"};